import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  BarChart3, 
  TrendingUp, 
  Wallet, 
  Trophy, 
  Medal, 
  User, 
  Settings,
  LogOut,
  Coins
} from 'lucide-react';

const Sidebar: React.FC = () => {
  const navItems = [
    { path: '/dashboard', icon: BarChart3, label: 'Dashboard', badge: null },
    { path: '/trading', icon: TrendingUp, label: 'Trading', badge: 'Live' },
    { path: '/portfolio', icon: Wallet, label: 'Portfolio', badge: null },
    { path: '/competitions', icon: Trophy, label: 'Competitions', badge: '3' },
    { path: '/leaderboard', icon: Medal, label: 'Leaderboard', badge: null },
    { path: '/profile', icon: User, label: 'Profile', badge: null },
  ];

  return (
    <div className="win-sidebar w-80 min-h-screen flex flex-col">
      {/* Logo Section */}
      <div className="p-6 border-b border-win-dark-border">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-gradient-to-br from-win-dark-gold to-win-dark-gold-dark rounded-3xl flex items-center justify-center win-glow-gold">
            <Coins className="w-6 h-6 text-win-dark-bg" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-win-dark-text">X Gold</h1>
            <p className="text-sm text-win-dark-text-muted">AI Trading Platform</p>
          </div>
        </div>
      </div>

      {/* User Info */}
      <div className="p-6 border-b border-win-dark-border">
        <div className="win-card p-4">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-win-dark-accent rounded-full flex items-center justify-center">
              <User className="w-5 h-5 text-white" />
            </div>
            <div>
              <p className="font-medium text-win-dark-text">John Doe</p>
              <div className="flex items-center gap-2">
                <span className="win-badge win-badge-gold">Gold Tier</span>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3 text-sm">
            <div className="text-center">
              <p className="text-win-dark-text-muted">Points</p>
              <p className="font-bold text-win-dark-gold">2,450</p>
            </div>
            <div className="text-center">
              <p className="text-win-dark-text-muted">Trades</p>
              <p className="font-bold text-win-dark-text">47/100</p>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-6">
        <div className="space-y-2">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `win-nav-item ${isActive ? 'active' : ''}`
              }
            >
              <item.icon className="w-5 h-5" />
              <span className="flex-1">{item.label}</span>
              {item.badge && (
                <span className="win-badge win-badge-success">
                  {item.badge}
                </span>
              )}
            </NavLink>
          ))}
        </div>
      </nav>

      {/* Bottom Actions */}
      <div className="p-6 border-t border-win-dark-border space-y-2">
        <button className="win-nav-item w-full">
          <Settings className="w-5 h-5" />
          <span>Settings</span>
        </button>
        <button className="win-nav-item w-full text-win-dark-error hover:bg-win-dark-error/20">
          <LogOut className="w-5 h-5" />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;